<div #scrollContainer class="scroll-container" [style.height]="height">
  <div #content class="content" (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>
  <div #scrollbar class="scrollbar">
    <div #thumb class="thumb" (mousedown)="onMouseDown($event)"></div>
  </div>
</div>
